module.exports = __webpack_public_path__ + "img/icone-relatorios-1.bed1a40a.svg";